// extracted by mini-css-extract-plugin
export default {"row":"ScoopRow_row__lDWKk"};